export const BASE_URL = 'https://strapi.gery.me';
export const API_TOKEN = process.env.REACT_APP_API_TOKEN
